export const SIDE_MENU_ROUTE_MAPPER = {
  HOME: '/home',
  SIGIN: '/home',
  FIND_JOBS: '/findjobs',
  MY_JOBS: '/myjobstatus',
  SURVEY: '/survey',
  MY_REFERRALS: '/myreferralslist',
  FORUM: '/forum',
  TIMESHEETS: '/timesheet',
  HELP: '/help',
  JOB_ALERTS: '/jobAlert',
  REFER_A_FRIEND: '/referafriend',
  INBOX: '/inbox',
  Privacy_And_Consent : '/privacyconsent'

};

